import React from "react";

import styles from './styles/XContentForm.module.scss';

export interface IContentFormProps {
    className?: string | null;
    children? : React.ReactNode;
    height? : string | null;
    width? : string | null;
    flexGrow? : number | null;
    text?: string | null;
    isActive?: boolean | null;
    //name:string;
    //optionalParam?:number;
}
export interface IContentFormState {
}
export class XContentForm extends React.Component<IContentFormProps, IContentFormState> {
    constructor(props: any) {
        super(props);
    }
    render() : React.ReactNode
    {
        return (
            <div className={styles.XContentForm}>{this.props.children}</div>
        );
    }
}